<pbc-filter-preset
  [filter]="berichtsVorlagen.preset$ | async"
  [filters]="berichtsVorlagen.presets$ | async"
  [name]="berichtsVorlagen.search$ | async"
  (select)="berichtsVorlagen.setFilter($event)"
  (save)="berichtsVorlagen.writeFilter($event)"
  (delete)="berichtsVorlagen.deleteFilter($event)"
></pbc-filter-preset>
